import React from 'react';

import { StyledContainer, StyledMessage } from './styles';

const SorryMessage = () => {
  return (
    <StyledContainer>
      <StyledMessage>
        Sorry, we don't have any articles that answer your question. Try asking your question in chat!
      </StyledMessage>
    </StyledContainer>
  );
};

export default SorryMessage;